import React from "react";
import { Image } from "antd";

/**
 * Reusable Assignment Method Card Component
 *
 * @param {Object} props - Component props
 * @param {string} props.icon - Icon component or path
 * @param {string} props.title - Card title
 * @param {string} props.description - Card description
 * @param {Function} props.onClick - Click handler
 * @param {string} props.className - Additional CSS classes
 */
const AssignmentMethodCard = ({ icon, title, description, onClick, className = "" }) => {
  return (
    <div
      onClick={onClick}
      className={`
        flex items-start gap-3 p-4
        border border-solid border-[#D9D9D9] rounded-lg
        cursor-pointer hover:border-[#1890ff] hover:bg-[#f0f5ff]
        transition-all duration-200
        ${className}
      `}
    >
      {/* Icon Container */}

      <Image src={icon} alt={title} preview={false} />

      {/* Content */}
      <div className="flex-1">
        <h4 className="text-sm font-bold text-black-88 mb-1">{title}</h4>
        <p className="text-black-65  text-xs font-normal leading-relaxed">{description}</p>
      </div>
    </div>
  );
};

export default AssignmentMethodCard;
